export default __webpack_public_path__ + "static/media/misSolicitudes.f6ef64d7.png";